import {ContentInfo} from "./content-info";

export class ArticleEditInfo {
  constructor(public id: string,
              public title: string,
              public text: string,
              public audio: ContentInfo,
              public picture: ContentInfo,
              public is_paid: boolean) {
  }
}



// WEBPACK FOOTER //
// /home/developer/Downloads/SleepRestoreBackend/sleep-restore-boot/src/main/ngapp/src/app/model/article-edit-info.ts